// extracted by mini-css-extract-plugin
export default {"moreInfo":"style_moreInfo__zrle1","content":"style_content__1BuKo","rules":"style_rules__9e8aG"};